import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/wishlist/components/WishlistTable.tsx");
